import { Dialog } from "@headlessui/react"
import { IKImage } from 'imagekitio-react'
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import moment from 'moment'
import { SET_USER_PRICING_CARD_ID } from "../../redux/actions/types"

export default function DiscountModal({ openDiscountModal, modalData, setDiscountModal, modalType }) {


    const name = useSelector(store => store?.profileDetails?.name)
    const date = moment(modalData?.expires_at ? modalData?.expires_at : (Date.now() + 86400000)).format('Do MMMM YYYY')
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (
        <div>
            <Dialog open={openDiscountModal}
                onClose={() =>
                    setDiscountModal(prev => ({ ...prev, open: false, data: null }))
                }
                as="div"
                style={{ zIndex: '9999999999' }}
                className="fixed inset-0 z-10 overflow-y-auto flex md:justify-start md:mt-20 justify-center flex-col items-center">
                <Dialog.Overlay className="fixed inset-0 bg-black opacity-70 z-10" />
                <Dialog.Title />
                <Dialog.Description />
                <div className='bg-white z-10 md:w-2/3 lg:w-[30rem] md:h-[30rem] w-5/6 h-[32rem] rounded-2xl flex flex-col justify-between py-4 px-4 items-center md:p-4 text-center shadow-2xl'>
                    <img
                        urlEndpoint="https://assets.learntube.ai/files/"
                        src='https://assets.learntube.ai/files/PRICING/Happy_friends_drinking_wine_or_beer_together__Converted_.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662028563407'
                        className="w-full h-32 md:w-full md:h-36"
                        transformation={[{
                            "height": "160",
                            "width": "160",
                        }]}
                    />
                    <div className="flex flex-col w-full h-full justify-between items-center p-2 py-4" >
                        <h1 className="text-2xl font-bold">Congrats! {modalData?.discount ? modalData?.discount : '55'}% discount Unlocked</h1>
                        <p className="text-sm md:text-base">{name}, you’ve unlocked upto {modalData?.discount ? modalData?.discount : '55'}% off on LearnTube Pro plans for {modalType?.message}. Discount valid till: {date}</p>
                    </div>
                    <div className="flex flex-col w-full h-full justify-start items-center p-2 py-4" >
                        <button style={{ background: 'linear-gradient(238.65deg, #13A0BD 20%, #086788 89.97%)' }} className="text-white mb-5 px-6 py-2 rounded-3xl md:text-sm text-xs md:w-[70%] w-full" onClick={(event) => { dispatch({ type: SET_USER_PRICING_CARD_ID, payload: 1 }); navigate('/pricing') }} ><span className="font-semibold">Get 100% Placement Support Plan</span><br /><span className="text-xs">starts Rs. 89/month</span></button>
                        <button className="text-[#086788] font-bold border-2 border-[#086788] px-5 py-1 rounded-3xl md:text-sm text-xs md:w-[70%] w-full" onClick={(event) => { dispatch({ type: SET_USER_PRICING_CARD_ID, payload: 3 }); navigate('/pricing') }}><span className="font-semibold">Get Unlimited Certification Plan</span><br /><span className="text-xs">starts Rs. 167/month</span></button>
                    </div>
                </div>
            </Dialog>

        </div>
    )
}